import { PLATFORM } from "../constants";

export const isBrowserEnv = () => {
    return typeof window !== "undefined";
};

export const isIOS = (): boolean => {
    return isBrowserEnv() && window.webkit?.messageHandlers?.nativeRequest !== undefined;
};

export const isAndroid = (): boolean => {
    return isBrowserEnv() && window.AndroidBridge !== undefined;
};

export const getPlatForm = (): string => {
    if (isIOS()) {
        return PLATFORM.IOS;
    } else if (isAndroid()) {
        return PLATFORM.ANDROID;
    } else {
        return PLATFORM.WEB;
    }
};

export const isApp = () =>
    typeof window !== "undefined" &&
    (!!window.AndroidBridge?.nativeRequest || !!window.webkit?.messageHandlers?.nativeRequest);
